export default {
  freeTimesLimitTitle: "La prova per l'account gratuito si esaurisce oggi.",
  fileSizeLimitTitle:
    "La dimensione del file per l'account gratuito non può superare i 20 MB.",
  total: 'Totale',
  enterCode: 'Inserisci il codice',
  signUpToPurchaseBtn: 'Registra per acquistare',
  goPurchseBtn: "Vai all'acquisto",
  saveTips: 'Risparmia fino al {{num}}%',
  discount: 'Sconto',
  montly: 'Mensile',
  yearly: 'Annuale',
  weekly: 'Settimana',
  week: 'Settimana',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYearly: '3,75€',
  billMonth: '29,99€ Pagato Mensilmente',
  billYear: '179,99€ Pagato Annualmente',
  AlreadySubscribe: 'Già iscritto?',
  vipTips1: 'Nessun limite di dimensione dei file',
  vipTips2: 'Elaborazione di quantità di file senza limiti',
  vipTips3: 'Modificare gli sfondi delle immagini senza limiti',
  vipTips4: 'Accesso a tutti gli strumenti gratuiti e alle funzioni premium',
  purchaseTips: 'Rinnova automaticamente e annulla in qualsiasi momento.',
  tips: 'Suggerimenti:',
  promoCodeInvalidTips: 'Il tuo codice promozionale non è valido',
};
